import React from 'react';
import {
  Button,
  Columns,
  Column,
  Heading,
  Stack,
  Text,
  TextLink,
  Box,
} from '@origin-digital/ods-core';
import { CUSTOMER_TYPE, CustomerType } from '@origin-digital/sales-common';

type Props = {
  customerType: CustomerType;
  isEspec?: boolean;
  searchTerm?: string;
};

export const CESErrorAlert = ({ customerType, isEspec, searchTerm }: Props) => {
  // Same-origin in every env (web-router serves /ces and /espec/ces on the app's own origin),
  // so link relative — no per-env base needed. customerType + searchTerm are forwarded so the
  // new CES app can pre-fill once it supports them (not handled there yet — pending UX).
  const cesAppPath = isEspec ? '/espec/ces' : '/ces';
  const getLinkUrl = (linkCustomerType: CustomerType) => {
    const params = new URLSearchParams({ customerType: linkCustomerType });
    if (searchTerm) params.set('searchTerm', searchTerm);
    return `${cesAppPath}?${params.toString()}`;
  };

  return (
    <Box backgroundColor="transparent" data-testid="address-ces-error">
      <Columns alignX="center" collapseBelow="md" space="small">
        <Column width="2/3">
          <Stack space="large" alignX="center">
            <Stack alignX="center" space="medium">
              <img
                src="https://www.originenergy.com.au/cdn/images/originenergy/image/upload/v1726134966/spot_CES_contained-white.svg"
                alt="ces services"
                height="96px"
              />
              <Heading variant="h4" align="center">
                Great news. We offer energy services at your building.
              </Heading>
              {customerType === CUSTOMER_TYPE.RESIDENTIAL && (
                <Text align="center">
                  As you live in a unit or apartment building that is part of an embedded network,
                  we have a different offer for you. Just select your exact address in the next step
                  to get your energy service connected.
                </Text>
              )}
              {customerType === CUSTOMER_TYPE.BUSINESS && (
                <Text align="center">
                  As you run a business in a building that is part of an embedded network, we have a
                  different offer for you. Just select your exact address in the next step to get
                  your energy service connected.
                </Text>
              )}
            </Stack>
            <Button href={getLinkUrl(customerType)}>Show available energy services</Button>
            <Text align="center">
              {customerType === CUSTOMER_TYPE.RESIDENTIAL && (
                <TextLink href={getLinkUrl(CUSTOMER_TYPE.BUSINESS)}>
                  Are you a business customer?
                </TextLink>
              )}
              {customerType === CUSTOMER_TYPE.BUSINESS && (
                <TextLink href={getLinkUrl(CUSTOMER_TYPE.RESIDENTIAL)}>
                  Are you a residential customer?
                </TextLink>
              )}
            </Text>
          </Stack>
        </Column>
      </Columns>
    </Box>
  );
};
